<template>
	<QaLayout>
		<QaItem3/>
	</QaLayout>
</template>

<script>
import QaItem3 from './qaItem3.vue';
import QaLayout from './qaLayout.vue';
export default {
	components: {
		QaLayout,
		QaItem3
	}
}
</script>
